import { stripe } from "Config/config";

export default {
  subscription: null,
  plans: {
    freemium: {
      id: "freemium",
      level: 0,
      name: "Freemium",
      price: "$0",
      features: ["Hasta $500 en órdenes en un mes", "Hasta 0.5 GB en descargas"],
      value_max: 500,
    },
    incuba: {
      id: "incuba",
      level: 1,
      name: "Incuba",
      price: "$10",
      features: ["Hasta $2500 en órdenes en un mes", "Hasta 1 GB en descargas"],
      value_max: 2500,
      lineItems: [{ price: stripe?.priceIds["incuba"], quantity: 1 }],
    },
    emprende: {
      id: "emprende",
      level: 2,
      name: "Emprende",
      price: "$35",
      features: ["Hasta $6500 en órdenes en un mes", "Hasta 2 GB en descargas"],
      value_max: 6500,
      lineItems: [{ price: stripe?.priceIds["emprende"], quantity: 1 }],
    },
    escala: {
      id: "escala",
      level: 3,
      name: "Escala",
      price: "$99",
      features: ["Hasta $15000 en órdenes en un mes", "Hasta 10 GB en descargas"],
      value_max: 15000,
      lineItems: [{ price: stripe?.priceIds["escala"], quantity: 1 }],
    },
  },
};
